import React, { useEffect, useRef } from "react";

function ytId(url) {
  const m = (url || "").match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return m ? m[1] : null;
}

function loadScript(src, id) {
  if (document.getElementById(id)) return Promise.resolve();
  return new Promise((res) => {
    const s = document.createElement("script");
    s.src = src; s.async = true; s.id = id; s.onload = res;
    document.body.appendChild(s);
  });
}

export function detectPlatform(url = "") {
  if (url.includes("tiktok")) return "tiktok";
  if (url.includes("youtu")) return "youtube";
  if (url.includes("instagram")) return "instagram";
  return "";
}

export function SocialEmbed({ platform, url }) {
  const ref = useRef(null);
  const p = platform || detectPlatform(url);

  useEffect(() => {
    if (p === "instagram") {
      loadScript("https://www.instagram.com/embed.js", "ig-embed").then(() => {
        window.instgrm?.Embeds?.process();
      });
    } else if (p === "tiktok") {
      loadScript("https://www.tiktok.com/embed.js", "tt-embed");
    }
  }, [p, url]);

  if (p === "youtube") {
    const id = ytId(url);
    if (id)
      return (
        <div className="aspect-video w-full overflow-hidden rounded-xl bg-black">
          <iframe
            title="YouTube video"
            src={`https://www.youtube.com/embed/${id}`}
            className="h-full w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      );
  }
  if (p === "instagram") {
    return (
      <blockquote
        ref={ref}
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="14"
        style={{ background: "#fff", border: 0, margin: 0, width: "100%", minWidth: "auto" }}
      />
    );
  }
  if (p === "tiktok") {
    const idm = (url || "").match(/video\/(\d+)/);
    return (
      <blockquote className="tiktok-embed" cite={url} data-video-id={idm ? idm[1] : ""} style={{ maxWidth: "100%", minWidth: "auto" }}>
        <section />
      </blockquote>
    );
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="text-emerald-600 underline">
      Open post
    </a>
  );
}
